import type { QuestionTranslateOptionSchema, QuestionTranslateSchema } from '@repo/schemas/quiz/questionTranslate';

import { useFormContext } from 'react-hook-form';

export function useQuestionTranslateAnswersForm(answerIndex: number) {
  const { getValues } = useFormContext<QuestionTranslateSchema>();

  const answer = getValues(`answers.${answerIndex}`) as number[];

  const options = getValues('options');

  const getAnswerOptions = (): QuestionTranslateOptionSchema[] => {
    return answer.map((optionId) => options.find((opt) => opt.id === optionId)).filter((opt): opt is QuestionTranslateOptionSchema => opt !== undefined);
  };

  return {
    answer,
    options,
    getAnswerOptions,
  };
}
